export const outputTypes = ['archive', 'print', 'email', 'ftp'];

export const statusMap = {
  1: {
    label: 'New',
    icon: () => <i className="fas fa-ellipsis-h" title="New" />,
  },
  2: {
    label: 'Queued',
    icon: () => <i className="text-warning fad fa-hourglass-start" title="Queued" />,
  },
  3: {
    label: 'Started',
    icon: () => <i className="text-success fad fa-hourglass-half text-bold" title="Started" />,
  },
  400: {
    label: 'Failed',
    icon: () => <i className="text-warning fas fa-times text-bold" title="Failed" />,
  },
  500: {
    label: 'Stopped',
    icon: () => <i className="text-danger fas fa-times text-bold" title="Stopped" />,
  },
  501: {
    label: 'Canceled',
    icon: () => <i className="text-danger fas-fa-ban text-bold" title="Canceled" />,
  },
  502: {
    label: 'Skipped',
    icon: () => <i className="text-danger fas fa-octagon text-bold" title="Skipped" />,
  },
  503: {
    label: 'Fatal',
    icon: () => <i className="text-danger fad fa-exclamation-square text-bold" title="Fatal" />,
  },
};

export const getStatus = statusCode => {
  if (!statusCode) {
    return null;
  }

  statusCode = parseInt(statusCode);
  if (statusCode > 1000) {
    return {
      label: 'Done',
      icon: () => <i class="text-success fad fa-check text-bold" title="Done" />,
      ts: statusCode,
    };
  }

  return statusMap[statusCode];
};
